import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  primary: "#322D72",
  secondary: "#E98841",
  default: "#667085",
  lightdark: "#333843",
  lightgrey: "#DEDEFA",
  iconintable: "#667085",
  radial1: "rgba(39,11,121,0.3)", // RGB 1
  radial2: "rgba(228,96,44,0.3)", // RGB 2
  radial3: "rgba(228,96,44,0.3)", // RGB 3
  transparent1: "transparent 20%", // Transparent 1
  transparent2: "transparent 20%", // Transparent 2
  transparent3: "transparent 20%", // Transparent 3
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setColorTheme: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setColorTheme } = themeSlice.actions;
export default themeSlice.reducer;
